var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5165 8.37779V17.6222M8.89427 13H18.1387M25.0721 13C25.0721 19.382 19.8985 24.5556 13.5165 24.5556C7.13454 24.5556 1.96094 19.382 1.96094 13C1.96094 6.61805 7.13454 1.44446 13.5165 1.44446C19.8985 1.44446 25.0721 6.61805 25.0721 13Z",
    stroke: "#0092DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleActive);
export default __webpack_public_path__ + "static/media/plus_circle_active.2f9ffa1a48c98d353d96e61fc485e348.svg";
export { ForwardRef as ReactComponent };